import { useCurrency } from '@kss/currency';
import { cn } from '../lib/cn';

/**
 * Price display with an optional discount: shows the selling price, the
 * struck-through MRP, and the computed "N% OFF" when mrp > price. Wraps the
 * discount to a second line in narrow (grid-card) contexts.
 */
export function PriceTag({
  price,
  mrp,
  className
}: {
  price: number;
  mrp?: number;
  className?: string;
}) {
  const { format } = useCurrency();
  const off = mrp && mrp > price ? Math.round((1 - price / mrp) * 100) : 0;
  return (
    <span className={cn('flex flex-wrap items-baseline gap-x-1.5 gap-y-0.5', className)}>
      <b className='text-[14px]'>{format(price)}</b>
      {off > 0 && (
        <>
          <span className='text-[11px] text-content-muted line-through'>{format(mrp!)}</span>
          <span className='text-[10px] font-extrabold text-veg'>{off}% OFF</span>
        </>
      )}
    </span>
  );
}
